module.exports = "https://static.energy5.com/_next/static/images/glance-2-1d6cedc04bc6877ba0864b11a8b73b61.png";